import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store/store';
import { CheckToken } from '../api/auth';
import { SET_HASH } from '../store/modules/user-mutation-type';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.query.hash) {
    store.commit(`user/${SET_HASH}`, to.query.hash);
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['user/isConnected']) {
      next({ name: 'connexion' });
    } else {
      await CheckToken();
      next();
    }
  } else {
    next();
  }
});

export default router;
